import { render, staticRenderFns } from "./ProgettoRiabilitativoIndividualeListComponent.vue?vue&type=template&id=1b3bed7c"
import script from "./ProgettoRiabilitativoIndividualeListComponent.vue?vue&type=script&lang=js"
export * from "./ProgettoRiabilitativoIndividualeListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports